export default __webpack_public_path__ + "static/media/elo.dfb10a60.png";